

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.0qZQ38Uc.js","_app/immutable/chunks/yI7QhVT-.js","_app/immutable/chunks/DdBbTIYF.js","_app/immutable/chunks/DwKR0wUy.js","_app/immutable/chunks/B7lD3_W4.js","_app/immutable/chunks/BT_zozEV.js","_app/immutable/chunks/Cop0Gd8t.js","_app/immutable/chunks/CQVtHfxE.js","_app/immutable/chunks/CTRjNHmM.js","_app/immutable/chunks/DMZiD_i_.js"];
export const stylesheets = [];
export const fonts = [];
